import endpoint from "../../config/endpoints";

export const ClaimAttendanceJson = {
    showSaveNextBtn: true,
    apiBaseURL: endpoint.stockStakeholderOrderHeader,
    screenTitle: "Claim Attendance",
    fieldMeta: [
        {
            label: "Sales Team",
            controlType: "autocomplete",
            placeHolder: "Select Sales Team",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "salesTeamDetail",
            dataKey: "salesTeam",
            isRootLevelKey: true,
            isMandatory: false,
        },
        {
            label: "Month",
            controlType: "monthpicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "month",
            isMandatory: true,
        },
    ],

    fieldMetaEmpty: [],
};
